module.exports = __webpack_public_path__ + "static/media/Appl_Sign.0bbfbfe6.svg";